import { render, staticRenderFns } from "./ProcesosInternoFacilisimo.vue?vue&type=template&id=2e650e90&scoped=true"
import script from "./ProcesosInternoFacilisimo.vue?vue&type=script&lang=js"
export * from "./ProcesosInternoFacilisimo.vue?vue&type=script&lang=js"
import style0 from "./ProcesosInternoFacilisimo.vue?vue&type=style&index=0&id=2e650e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e650e90",
  null
  
)

export default component.exports